/**
 * IRS CountryType: every country name and code the schema accepts - generated, not written.
 *
 * Source: schemas/TY2026/COMMON/IRS-IRefileTypes.xsd. Regenerate with:
 *
 *   node packages/iris-engine/scripts/extract-country-codes.mjs
 *
 * 258 countries. Keys are UPPERCASE names and the codes themselves, so a file that says
 * "CANADA", "Canada" or "CA" all resolve. Generated 2026-10-21. Do not edit by hand.
 */

export const IRS_COUNTRY_CODES: Record<string, string> = {
  "AFGHANISTAN": "AF",
  "AF": "AF",
  "AKROTIRI": "AX",
  "AX": "AX",
  "ALBANIA": "AL",
  "AL": "AL",
  "ALGERIA": "AG",
  "AG": "AG",
  "AMERICAN SAMOA": "AQ",
  "AQ": "AQ",
  "ANDORRA": "AN",
  "AN": "AN",
  "ANGOLA": "AO",
  "AO": "AO",
  "ANGUILLA": "AV",
  "AV": "AV",
  "ANTARCTICA": "AY",
  "AY": "AY",
  "ANTIGUA AND BARBUDA": "AC",
  "AC": "AC",
  "ARGENTINA": "AR",
  "AR": "AR",
  "ARMENIA": "AM",
  "AM": "AM",
  "ARUBA": "AA",
  "AA": "AA",
  "ASHMORE AND CARTIER ISLANDS": "AT",
  "AT": "AT",
  "AUSTRALIA": "AS",
  "AS": "AS",
  "AUSTRIA": "AU",
  "AU": "AU",
  "AZERBAIJAN": "AJ",
  "AJ": "AJ",
  "BAHAMAS": "BF",
  "BF": "BF",
  "BAHRAIN": "BA",
  "BA": "BA",
  "BAKER ISLAND": "FQ",
  "FQ": "FQ",
  "BANGLADESH": "BG",
  "BG": "BG",
  "BARBADOS": "BB",
  "BB": "BB",
  "BELARUS": "BO",
  "BO": "BO",
  "BELGIUM": "BE",
  "BE": "BE",
  "BELIZE": "BH",
  "BH": "BH",
  "BENIN": "BN",
  "BN": "BN",
  "BERMUDA": "BD",
  "BD": "BD",
  "BHUTAN": "BT",
  "BT": "BT",
  "BOLIVIA": "BL",
  "BL": "BL",
  "BOSNIA-HERZEGOVINA": "BK",
  "BK": "BK",
  "BOTSWANA": "BC",
  "BC": "BC",
  "BOUVET ISLAND": "BV",
  "BV": "BV",
  "BRAZIL": "BR",
  "BR": "BR",
  "BRITISH INDIAN OCEAN TERRITORY": "IO",
  "IO": "IO",
  "BRITISH VIRGIN ISLANDS": "VI",
  "VI": "VI",
  "BRUNEI": "BX",
  "BX": "BX",
  "BULGARIA": "BU",
  "BU": "BU",
  "BURKINA FASO": "UV",
  "UV": "UV",
  "BURMA": "BM",
  "BM": "BM",
  "BURUNDI": "BY",
  "BY": "BY",
  "CAMBODIA": "CB",
  "CB": "CB",
  "CAMEROON": "CM",
  "CM": "CM",
  "CANADA": "CA",
  "CA": "CA",
  "CAPE VERDE": "CV",
  "CV": "CV",
  "CAYMAN ISLANDS": "CJ",
  "CJ": "CJ",
  "CENTRAL AFRICAN REPUBLIC": "CT",
  "CT": "CT",
  "CHAD": "CD",
  "CD": "CD",
  "CHILE": "CI",
  "CI": "CI",
  "CHINA": "CH",
  "CH": "CH",
  "CHRISTMAS ISLAND": "KT",
  "KT": "KT",
  "CLIPPERTON ISLAND": "IP",
  "IP": "IP",
  "COCOS (KEELING) ISLANDS": "CK",
  "CK": "CK",
  "COLOMBIA": "CO",
  "CO": "CO",
  "COMOROS": "CN",
  "CN": "CN",
  "CONGO (BRAZZAVILLE)": "CF",
  "CF": "CF",
  "CONGO (KINSHASA)": "CG",
  "CG": "CG",
  "COOK ISLANDS": "CW",
  "CW": "CW",
  "CORAL SEA ISLANDS": "CR",
  "CR": "CR",
  "COSTA RICA": "CS",
  "CS": "CS",
  "COTE D'IVOIRE (IVORY COAST)": "IV",
  "IV": "IV",
  "CROATIA": "HR",
  "HR": "HR",
  "CUBA": "CU",
  "CU": "CU",
  "CURACAO": "UC",
  "UC": "UC",
  "CYPRUS": "CY",
  "CY": "CY",
  "CZECH REPUBLIC": "EZ",
  "EZ": "EZ",
  "DENMARK": "DA",
  "DA": "DA",
  "DHEKELIA": "DX",
  "DX": "DX",
  "DJIBOUTI": "DJ",
  "DJ": "DJ",
  "DOMINICA": "DO",
  "DO": "DO",
  "DOMINICAN REPUBLIC": "DR",
  "DR": "DR",
  "EAST TIMOR": "TT",
  "TT": "TT",
  "ECUADOR": "EC",
  "EC": "EC",
  "EGYPT": "EG",
  "EG": "EG",
  "EL SALVADOR": "ES",
  "ES": "ES",
  "EQUATORIAL GUINEA": "EK",
  "EK": "EK",
  "ERITREA": "ER",
  "ER": "ER",
  "ESTONIA": "EN",
  "EN": "EN",
  "ETHIOPIA": "ET",
  "ET": "ET",
  "FALKLAND ISLANDS (ISLAS MALVINAS)": "FK",
  "FK": "FK",
  "FAROE ISLANDS": "FO",
  "FO": "FO",
  "FEDERATED STATES OF MICRONESIA": "FM",
  "FM": "FM",
  "FIJI": "FJ",
  "FJ": "FJ",
  "FINLAND": "FI",
  "FI": "FI",
  "FRANCE": "FR",
  "FR": "FR",
  "FRENCH POLYNESIA": "FP",
  "FP": "FP",
  "FRENCH SOUTHERN AND ANTARCTIC LANDS": "FS",
  "FS": "FS",
  "GABON": "GB",
  "GB": "GB",
  "THE GAMBIA": "GA",
  "GA": "GA",
  "GEORGIA": "GG",
  "GG": "GG",
  "GERMANY": "GM",
  "GM": "GM",
  "GHANA": "GH",
  "GH": "GH",
  "GIBRALTAR": "GI",
  "GI": "GI",
  "GREECE": "GR",
  "GR": "GR",
  "GREENLAND": "GL",
  "GL": "GL",
  "GRENADA": "GJ",
  "GJ": "GJ",
  "GUAM": "GQ",
  "GQ": "GQ",
  "GUATEMALA": "GT",
  "GT": "GT",
  "GUERNSEY": "GK",
  "GK": "GK",
  "GUINEA": "GV",
  "GV": "GV",
  "GUINEA-BISSAU": "PU",
  "PU": "PU",
  "GUYANA": "GY",
  "GY": "GY",
  "HAITI": "HA",
  "HA": "HA",
  "HEARD ISLAND AND MCDONALD ISLANDS": "HM",
  "HM": "HM",
  "HOLY SEE": "VT",
  "VT": "VT",
  "HONDURAS": "HO",
  "HO": "HO",
  "HONG KONG": "HK",
  "HK": "HK",
  "HOWLAND ISLAND": "HQ",
  "HQ": "HQ",
  "HUNGARY": "HU",
  "HU": "HU",
  "ICELAND": "IC",
  "IC": "IC",
  "INDIA": "IN",
  "IN": "IN",
  "INDONESIA": "ID",
  "ID": "ID",
  "IRAN": "IR",
  "IR": "IR",
  "IRAQ": "IZ",
  "IZ": "IZ",
  "IRELAND": "EI",
  "EI": "EI",
  "ISRAEL": "IS",
  "IS": "IS",
  "ITALY": "IT",
  "IT": "IT",
  "JAMAICA": "JM",
  "JM": "JM",
  "JAN MAYEN": "JN",
  "JN": "JN",
  "JAPAN": "JA",
  "JA": "JA",
  "JARVIS ISLAND": "DQ",
  "DQ": "DQ",
  "JERSEY": "JE",
  "JE": "JE",
  "JOHNSTON ATOLL": "JQ",
  "JQ": "JQ",
  "JORDAN": "JO",
  "JO": "JO",
  "KAZAKHSTAN": "KZ",
  "KZ": "KZ",
  "KENYA": "KE",
  "KE": "KE",
  "KINGMAN REEF": "KQ",
  "KQ": "KQ",
  "KIRIBATI": "KR",
  "KR": "KR",
  "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF (NORTH)": "KN",
  "KN": "KN",
  "KOREA, REPUBLIC OF (SOUTH)": "KS",
  "KS": "KS",
  "KOSOVO": "KV",
  "KV": "KV",
  "KUWAIT": "KU",
  "KU": "KU",
  "KYRGYZSTAN": "KG",
  "KG": "KG",
  "LAOS": "LA",
  "LA": "LA",
  "LATVIA": "LG",
  "LG": "LG",
  "LEBANON": "LE",
  "LE": "LE",
  "LESOTHO": "LT",
  "LT": "LT",
  "LIBERIA": "LI",
  "LI": "LI",
  "LIBYA": "LY",
  "LY": "LY",
  "LIECHTENSTEIN": "LS",
  "LS": "LS",
  "LITHUANIA": "LH",
  "LH": "LH",
  "LUXEMBOURG": "LU",
  "LU": "LU",
  "MACAU": "MC",
  "MC": "MC",
  "MACEDONIA": "MK",
  "MK": "MK",
  "MADAGASCAR": "MA",
  "MA": "MA",
  "MALAWI": "MI",
  "MI": "MI",
  "MALAYSIA": "MY",
  "MY": "MY",
  "MALDIVES": "MV",
  "MV": "MV",
  "MALI": "ML",
  "ML": "ML",
  "MALTA": "MT",
  "MT": "MT",
  "MAN, ISLE OF": "IM",
  "IM": "IM",
  "MARSHALL ISLANDS": "RM",
  "RM": "RM",
  "MAURITANIA": "MR",
  "MR": "MR",
  "MAURITIUS": "MP",
  "MP": "MP",
  "MEXICO": "MX",
  "MX": "MX",
  "MIDWAY ISLANDS": "MQ",
  "MQ": "MQ",
  "MOLDOVA": "MD",
  "MD": "MD",
  "MONACO": "MN",
  "MN": "MN",
  "MONGOLIA": "MG",
  "MG": "MG",
  "MONTENEGRO": "MJ",
  "MJ": "MJ",
  "MONTSERRAT": "MH",
  "MH": "MH",
  "MOROCCO": "MO",
  "MO": "MO",
  "MOZAMBIQUE": "MZ",
  "MZ": "MZ",
  "NAMIBIA": "WA",
  "WA": "WA",
  "NAURU": "NR",
  "NR": "NR",
  "NAVASSA ISLAND": "BQ",
  "BQ": "BQ",
  "NEPAL": "NP",
  "NP": "NP",
  "NETHERLANDS": "NL",
  "NL": "NL",
  "NEW CALEDONIA": "NC",
  "NC": "NC",
  "NEW ZEALAND": "NZ",
  "NZ": "NZ",
  "NICARAGUA": "NU",
  "NU": "NU",
  "NIGER": "NG",
  "NG": "NG",
  "NIGERIA": "NI",
  "NI": "NI",
  "NIUE": "NE",
  "NE": "NE",
  "NORFOLK ISLAND": "NF",
  "NF": "NF",
  "NORTHERN MARIANA ISLANDS": "CQ",
  "CQ": "CQ",
  "NORWAY": "NO",
  "NO": "NO",
  "OMAN": "MU",
  "MU": "MU",
  "OTHER COUNTRY": "OC",
  "OC": "OC",
  "PAKISTAN": "PK",
  "PK": "PK",
  "PALAU": "PS",
  "PS": "PS",
  "PALMYRA ATOLL": "LQ",
  "LQ": "LQ",
  "PANAMA": "PM",
  "PM": "PM",
  "PAPUA-NEW GUINEA": "PP",
  "PP": "PP",
  "PARACEL ISLANDS": "PF",
  "PF": "PF",
  "PARAGUAY": "PA",
  "PA": "PA",
  "PERU": "PE",
  "PE": "PE",
  "PHILIPPINES": "RP",
  "RP": "RP",
  "PITCAIRN ISLANDS": "PC",
  "PC": "PC",
  "POLAND": "PL",
  "PL": "PL",
  "PORTUGAL": "PO",
  "PO": "PO",
  "PUERTO RICO": "RQ",
  "RQ": "RQ",
  "QATAR": "QA",
  "QA": "QA",
  "ROMANIA": "RO",
  "RO": "RO",
  "RUSSIA": "RS",
  "RS": "RS",
  "RWANDA": "RW",
  "RW": "RW",
  "SAINT BARTHELEMY": "TB",
  "TB": "TB",
  "SAINT MARTIN": "RN",
  "RN": "RN",
  "SAMOA": "WS",
  "WS": "WS",
  "SAN MARINO": "SM",
  "SM": "SM",
  "SAO TOME AND PRINCIPE": "TP",
  "TP": "TP",
  "SAUDI ARABIA": "SA",
  "SA": "SA",
  "SENEGAL": "SG",
  "SG": "SG",
  "SERBIA": "RI",
  "RI": "RI",
  "SEYCHELLES": "SE",
  "SE": "SE",
  "SIERRA LEONE": "SL",
  "SL": "SL",
  "SINGAPORE": "SN",
  "SN": "SN",
  "SINT MAARTEN": "NN",
  "NN": "NN",
  "SLOVAKIA": "LO",
  "LO": "LO",
  "SLOVENIA": "SI",
  "SI": "SI",
  "SOLOMON ISLANDS": "BP",
  "BP": "BP",
  "SOMALIA": "SO",
  "SO": "SO",
  "SOUTH AFRICA": "SF",
  "SF": "SF",
  "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS": "SX",
  "SX": "SX",
  "SOUTH SUDAN": "OD",
  "OD": "OD",
  "SPAIN": "SP",
  "SP": "SP",
  "SPRATLY ISLANDS": "PG",
  "PG": "PG",
  "SRI LANKA": "CE",
  "CE": "CE",
  "ST. HELENA": "SH",
  "SH": "SH",
  "ST. KITTS AND NEVIS": "SC",
  "SC": "SC",
  "ST. LUCIA ISLAND": "ST",
  "ST": "ST",
  "ST. PIERRE AND MIQUELON": "SB",
  "SB": "SB",
  "ST. VINCENT AND THE GRENADINES": "VC",
  "VC": "VC",
  "SUDAN": "SU",
  "SU": "SU",
  "SURINAME": "NS",
  "NS": "NS",
  "SVALBARD": "SV",
  "SV": "SV",
  "SWAZILAND": "WZ",
  "WZ": "WZ",
  "SWEDEN": "SW",
  "SW": "SW",
  "SWITZERLAND": "SZ",
  "SZ": "SZ",
  "SYRIA": "SY",
  "SY": "SY",
  "TAIWAN": "TW",
  "TW": "TW",
  "TAJIKISTAN": "TI",
  "TI": "TI",
  "TANZANIA": "TZ",
  "TZ": "TZ",
  "THAILAND": "TH",
  "TH": "TH",
  "TOGO": "TO",
  "TO": "TO",
  "TOKELAU": "TL",
  "TL": "TL",
  "TONGA": "TN",
  "TN": "TN",
  "TRINIDAD AND TOBAGO": "TD",
  "TD": "TD",
  "TUNISIA": "TS",
  "TS": "TS",
  "TURKEY": "TU",
  "TU": "TU",
  "TURKMENISTAN": "TX",
  "TX": "TX",
  "TURKS AND CAICOS ISLANDS": "TK",
  "TK": "TK",
  "TUVALU": "TV",
  "TV": "TV",
  "UGANDA": "UG",
  "UG": "UG",
  "UKRAINE": "UP",
  "UP": "UP",
  "UNITED ARAB EMIRATES": "AE",
  "AE": "AE",
  "UNITED KINGDOM (ENGLAND, NORTHERN IRELAND, SCOTLAND, AND WALES)": "UK",
  "UK": "UK",
  "URUGUAY": "UY",
  "UY": "UY",
  "UZBEKISTAN": "UZ",
  "UZ": "UZ",
  "VANUATU": "NH",
  "NH": "NH",
  "VENEZUELA": "VE",
  "VE": "VE",
  "VIETNAM": "VM",
  "VM": "VM",
  "VIRGIN ISLANDS": "VQ",
  "VQ": "VQ",
  "WAKE ISLAND": "WQ",
  "WQ": "WQ",
  "WALLIS AND FUTUNA": "WF",
  "WF": "WF",
  "WESTERN SAHARA": "WI",
  "WI": "WI",
  "YEMEN (ADEN)": "YM",
  "YM": "YM",
  "ZAMBIA": "ZA",
  "ZA": "ZA",
  "ZIMBABWE": "ZI",
  "ZI": "ZI",
  "MAN": "IM",
  "COTE D'IVOIRE": "IV",
  "FALKLAND ISLANDS": "FK",
  "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF": "KN",
  "KOREA, REPUBLIC OF": "KS",
  "UNITED KINGDOM": "UK",
  "YEMEN": "YM",
  "GREAT BRITAIN": "UK",
  "ENGLAND": "UK",
  "SCOTLAND": "UK",
  "WALES": "UK",
  "NORTHERN IRELAND": "UK",
  "IVORY COAST": "IV",
  "SOUTH KOREA": "KS",
  "NORTH KOREA": "KN"
};

/** The IRS code for a country name or code, or null if the schema does not know it. */
export function irsCountryCode(raw: unknown): string | null {
  const key = String(raw ?? "").trim().toUpperCase();
  if (!key) return null;
  return IRS_COUNTRY_CODES[key] ?? null;
}
